import React from 'react';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { BlockFieldColumn } from 'web-ui-components/lib/global/layout';
import { Field } from 'react-final-form';
import PropTypes from '../../../types';
import { Content } from '../../../infrastructure/content';
import { isDateValid } from '../../../utils/validation';
import { isEmpty } from '../../../utils';
import { DATE_FIELD, MONTH_FIELD, YEAR_FIELD } from '../../../utils/constants';

const required = allValues => {
  if (isDateValid(allValues)) {
    return undefined;
  }
  return 'Required';
};

class DateFieldInput extends React.Component {
  constructor(props) {
    super(props);
    this.autoTab = this.autoTab.bind(this);
  }
  autoTab(e, value, dateField, len, field2) {
    if (
      isEmpty(document.getElementById(dateField)) &&
      isEmpty(document.getElementById(field2)) &&
      document.getElementById(dateField).value.length === len
    ) {
      document.getElementById(field2).focus();
    }
    this.props.input.onChange({ ...value, [dateField]: e.target.value });
  }
  render() {
    const {
      input: { value },
      meta: { touched, error },
      name
    } = this.props;
    return (
      <Content>
        {({
          personDetailsDOB,
          dobValidationMessage,
          personDetailsDateValue,
          personDetailsMonthValue,
          personDetailsYearValue
        }) => (
          <FormField>
            <FieldHeader
              name={name}
              hasError={touched && !!error}
              title={personDetailsDOB}
              validationMessage={dobValidationMessage}
            />
            <FieldBody hasError={touched && !!error}>
              <BlockFieldColumn className="o-block-field__col--stack " column={1}>
                <label htmlFor="dateName" className="c-a-label">
                  <span className="c-a-label__title">{personDetailsDateValue}</span>
                </label>
                <Input
                  type="tel"
                  id={DATE_FIELD}
                  maxLength={2}
                  value={value.dateField}
                  onChange={e => this.autoTab(e, value, DATE_FIELD, 2, MONTH_FIELD)}
                />
              </BlockFieldColumn>
              <BlockFieldColumn className="o-block-field__col--stack" column={1}>
                <label htmlFor="monthName" className="c-a-label">
                  <span className="c-a-label__title">{personDetailsMonthValue}</span>
                </label>
                <Input
                  type="tel"
                  id={MONTH_FIELD}
                  maxLength={2}
                  value={value.monthField}
                  onChange={e => this.autoTab(e, value, MONTH_FIELD, 2, YEAR_FIELD)}
                />
              </BlockFieldColumn>
              <BlockFieldColumn className="o-block-field__col--stack" column={2}>
                <label htmlFor="yearName" className="c-a-label">
                  <span className="c-a-label__title">{personDetailsYearValue}</span>
                </label>
                <Input
                  type="tel"
                  id={YEAR_FIELD}
                  maxLength={4}
                  value={value.yearField}
                  onChange={e => this.autoTab(e, value, YEAR_FIELD)}
                />
              </BlockFieldColumn>
            </FieldBody>
          </FormField>
        )}
      </Content>
    );
  }
}

DateFieldInput.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.object
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  })
};

const DateField = () => (
  <Field
    name="dateOfBirth"
    value={{ dateField: '', monthField: '', yearField: '' }}
    component={DateFieldInput}
    validate={required}
  />
);

export default DateField;
